import { func } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import AddAttachment from '../AddAttachment';

function AddAttachmentButton(props) {
  const { toggle } = props;
  return (
    <>
      <ModalHeader toggle={toggle}>Upload Attachment</ModalHeader>
      <ModalBody>
        <AddAttachment {...props} />
      </ModalBody>
    </>
  );
}

AddAttachmentButton.propTypes = {
  onSuccess: func.isRequired,
  toggle: func.isRequired,
};

export default createModalToggle('Upload Attachment', AddAttachmentButton);
export { AddAttachmentButton }; // for unit tests
